module.exports = __webpack_public_path__ + "img/sravni.c2bab50.png";